import React from "react";
import { useDispatch } from "react-redux";

import SearchField from "../../../Common/SearchField";
import { getCategoryCourses } from "../../../../actions/tmsActions";

const appCode = "C-TMS";

function CategoryCourseSearch({ categoryId }) {
    const dispatch = useDispatch();
    const onSearch = (searchString) => dispatch(getCategoryCourses(categoryId, appCode, { searchString }));
    const onClear = () => dispatch(getCategoryCourses(categoryId, appCode));
    
    return (
        <SearchField
            onSearch={onSearch}
            onClear={onClear}
            label="Search courses"
            placeholder="Search courses"
        />
    );
}

export default CategoryCourseSearch;
